import { NavRoute } from '../../shared/navigation/nav.route.interface';
import { SecurityEnum } from '../security/security.enum';

export const getAdminNav: () => NavRoute = () => {
	return {
		name: 'Admin',
		security: 'securityAdministration',
		children: [
			// {
			// 	name: 'Dashboard',
			// 	exact: true,
			// 	path: 'administration/dashboard',
			// },
			{
				name: 'Users',
				security: s =>
					s?.securityAdministration?.viewUserList === SecurityEnum.FullAccess ||
					s?.securityAdministration?.loginHistory === SecurityEnum.FullAccess ||
					s?.canChangeSecurity,
				children: [
					{
						name: 'Global Audit History',
						security: s => s?.securityAdministration?.globalAuditHistory === SecurityEnum.FullAccess,
						exact: true,
						path: 'administration/global-audit-history',
					},
					{
						name: 'Login History',
						security: 'securityAdministration.loginHistory',
						path: 'administration/users/login-history',
					},
					{
						name: 'Security',
						security: 'canChangeSecurity',
						exact: true,
						path: 'administration/security/security-profiles',
					},
					{
						name: 'User List',
						security: 'securityAdministration.viewUserList',
						exact: true,
						path: 'administration/users',
					},
				],
			},
			{
				name: 'Quartz',
				security: s => s?.securityAdministration?.viewQuartzJobs === SecurityEnum.FullAccess,
				children: [
					{
						name: 'Scheduler',
						security: 'securityAdministration.viewQuartzJobs',
						exact: true,
						path: 'quartz',
						openNewTab: true,
					},
					{
						name: 'History',
						security: 'securityAdministration.viewQuartzJobs',
						exact: true,
						path: 'administration/quartz-history',
					},
				],
			},
			{
				name: 'Release Notes',
				security: s =>
					s?.securityAdministration?.editReleaseNotesWeb === SecurityEnum.FullAccess ||
					s?.securityAdministration?.editReleaseNotesMobile === SecurityEnum.FullAccess,
				children: [
					{
						name: 'Mobile Release Notes',
						security: 'securityAdministration.editReleaseNotesMobile',
						exact: true,
						path: 'administration/release-notes/mobile-release-notes-list',
					},
					{
						name: 'Web Release Notes',
						security: 'securityAdministration.editReleaseNotesWeb',
						exact: true,
						path: 'administration/release-notes/web-release-notes-list',
					},
				],
			},
		],
	};
};
